import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnUser } from '../user';

export class FsSecretCredentials extends SnModel {
  @Expose()
  public organization: string;

  @Expose()
  @Type(() => SnUser)
  public user: SnUser;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public description: string;

  @Expose()
  public type: string;

  @Expose()
  public isOrganizationOwned: boolean;

  @Expose()
  public isPrivate: boolean;

  @Expose()
  public name: string;

  @Expose()
  public id: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
